import {
    Button,
} from '@mui/material'

import parseErrorMessage from '../parseErrorMessage'

import {
    GENERAL_ERROR_MESSAGE_HEADER,
    GENERAL_ERROR_MESSAGE__SUB_HEADER_1,
    GENERAL_ERROR_MESSAGE__SUB_HEADER_2,
} from '../consts'

// We don't have access to ThemeProvider here, so we need to use inline styles
const styles = {
    button: {
        'margin-top': 20,
        color: '#FFFFFF',
        font: 'normal normal 400 20px/24px Roboto',
        backgroundColor: '#939393',
        width: 160,
        height: 60,
        padding: 0,
        boxShadow: '0px 1px 3px #939393',
        whiteSpace: 'nowrap',
        letterSpacing: '2.14px',
    },
    body: {
        width: '100%',
        height: '100%',
        display: 'flex',
        background: '#EFEFEF',
        'flex-direction': 'column',
        'justify-content': 'center',
        'align-items': 'center',
    },
    icon: {
        height: 64,
        width: 64,
    },
    title: {
        'font-size': 36,
        'padding-top': 20,
        'padding-bottom': 20,
        color: '#000000',
        'font-weight': '300',
    },
    subTitle: {
        color: '#000000',
        'font-size': 16,
        'font-weight': '400',
    },
}

const ErrorFallback = ({
    error,
    resetErrorBoundary,
}: Readonly<{
    error: {
        message?: string
    },
    resetErrorBoundary: () => void
}>) => {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught an error:', parseErrorMessage(error))

    return (
        <div style={styles.body}>
            <div style={styles.icon}>
                <img
                    style={styles.icon}
                    src="assets/images/icons/failed.svg"
                    alt="error"
                />
            </div>
            <div style={styles.title}>{GENERAL_ERROR_MESSAGE_HEADER}</div>
            <div style={styles.subTitle}>{GENERAL_ERROR_MESSAGE__SUB_HEADER_1}</div>
            <div style={styles.subTitle}>{GENERAL_ERROR_MESSAGE__SUB_HEADER_2}</div>
            <Button
                data-testid="ok-button"
                style={styles.button}
                onClick={resetErrorBoundary}
            >
                Refresh
            </Button>
        </div>
    )
}

export default ErrorFallback
